import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { brand } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-stone-950 text-stone-300">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <div className="h-10 w-10 rounded-xl bg-black overflow-hidden grid place-items-center"><img src="/brand/accu-desk-logo.png" alt="Accu Desk" className="h-full w-full object-contain"/></div>
              <div>
                <div className="font-semibold text-white">{brand.name}</div>
                <div className="text-[10px] uppercase tracking-wider text-stone-400">{brand.tagline}</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-stone-400 max-w-sm">Practice management for South African tax, accounting, bookkeeping and audit firms. One platform. Every deadline. Every client.</p>
            <div className="mt-6 space-y-2 text-sm">
              <div className="flex items-center gap-2"><MapPin size={14} className="text-emerald-400"/> Alberton, Johannesburg, South Africa 1449</div>
              <div className="flex items-center gap-2"><Mail size={14} className="text-emerald-400"/> info@accudesk.co.za</div>
              <div className="flex items-center gap-2"><Phone size={14} className="text-emerald-400"/> +27 79 622 6431</div>
            </div>
          </div>

          <div>
            <div className="text-white font-semibold mb-3">Product</div>
            <ul className="space-y-2 text-sm text-stone-400">
              <li><a href="/#platform" className="hover:text-white">Platform</a></li>
              <li><a href="/#pricing" className="hover:text-white">Pricing</a></li>
              <li><a href="/#audiences" className="hover:text-white">Who it&apos;s for</a></li>
              <li><a href="/#resources" className="hover:text-white">Resources</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-3">Company</div>
            <ul className="space-y-2 text-sm text-stone-400">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><a href="/#faq" className="hover:text-white">FAQ</a></li>
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold mb-3">Legal</div>
            <ul className="space-y-2 text-sm text-stone-400">
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
              <li><Link to="/privacy" className="hover:text-white">POPIA</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-stone-500">
          <div>&copy; {new Date().getFullYear()} Accu Desk &middot; Saber Accounting (Pty) Ltd. All rights reserved.</div>
          <div>Built in South Africa. POPIA-aligned. SARS &amp; CIPC ready.</div>
        </div>
      </div>
    </footer>
  );
}
